import { render, staticRenderFns } from "./ApartmentGallery.vue?vue&type=template&id=0ff67ee9&"
import script from "./ApartmentGallery.vue?vue&type=script&lang=js&"
export * from "./ApartmentGallery.vue?vue&type=script&lang=js&"
import style0 from "./ApartmentGallery.vue?vue&type=style&index=0&id=0ff67ee9&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff67ee9')) {
      api.createRecord('0ff67ee9', component.options)
    } else {
      api.reload('0ff67ee9', component.options)
    }
    module.hot.accept("./ApartmentGallery.vue?vue&type=template&id=0ff67ee9&", function () {
      api.rerender('0ff67ee9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/ApartmentGallery.vue"
export default component.exports